export default __webpack_public_path__ + "static/media/devider.37322336.svg";